<form
    *ngFor="let availableFilter of availableFilters; let filtersIndex = index"
    ClickOutside
    [hidden]="availableFilter.animatedState === 'up'"
    (clickOutside)="toggleFilterDropdownState(availableFilter)">

    <div id="{{availableFilter.className}}-group" class="job-search-filters-select" (click)="toggleFilterDropdownState(availableFilter)">{{availableFilter.headline}}<span class="filter-count" *ngIf="availableFilter.type === 'checkbox' && availableFilter.selectedOptionsCount > 0" [style.background-color]="themeColor">{{availableFilter.selectedOptionsCount}}</span><i class="icon icon-dropdown" aria-hidden="true"></i></div>

    <div class="job-search-filters-dropdown"  [ngClass]="availableFilter.className" [hidden]="availableFilter.animatedState === 'up'" [@slideUpDown]="availableFilter.animatedState">

        <div class="job-search-filters-dropdown-options">

            <div class="{{availableFilter.type}}" *ngFor="let options of availableFilter.options; let optionsIndex = index">
                <label>
                    <input
                        type="{{availableFilter.type}}"
                        name="{{availableFilter.className}}-group"
                        value="{{options.value}}"
                        [attr.aria-labelledby]="availableFilter.className + '-group'"
                        [checked]="options.selected === true"
                        (change)="onSelectionChange(filtersIndex, optionsIndex)">
                    <span>{{options.displayName}}</span>
                </label>
            </div>

        </div>

        <div class="job-search-filters-dropdown-footer">
            <a class="reset" (click)="reset(availableFilter)">Reset</a><a class="apply" (click)="apply(availableFilter)">Apply</a>
        </div>

    </div>

</form>